/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  PriceChart actions index
 */

import type { PriceChartData } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import {
  CLEAR_HOOD_PRICE_CHART_DATA,
  CLEAR_PRICE_CHART_DATA,
  DONE_FETCHING_CITY_PRICE_CHART_DATA,
  DONE_FETCHING_HOOD_PRICE_CHART_DATA,
  ERROR_FETCHING_CITY_PRICE_CHART_DATA,
  ERROR_FETCHING_HOOD_PRICE_CHART_DATA,
  SET_CITY_PRICE_CHART_DATA,
  SET_HOOD_PRICE_CHART_DATA,
  START_FETCHING_CITY_PRICE_CHART_DATA,
  START_FETCHING_HOOD_PRICE_CHART_DATA,
} from '../constants/detail'

// fetching
export const doneFetchingCityPriceChartData = createAction(DONE_FETCHING_CITY_PRICE_CHART_DATA)
export const errorFetchingCityPriceChartData = createAction(ERROR_FETCHING_CITY_PRICE_CHART_DATA)
export const startFetchingCityPriceChartData = createAction<
  { key: string },
  typeof START_FETCHING_CITY_PRICE_CHART_DATA
>(START_FETCHING_CITY_PRICE_CHART_DATA)

export const doneFetchingHoodPriceChartData = createAction(DONE_FETCHING_HOOD_PRICE_CHART_DATA)
export const errorFetchingHoodPriceChartData = createAction(ERROR_FETCHING_HOOD_PRICE_CHART_DATA)
export const startFetchingHoodPriceChartData = createAction<
  { key: string },
  typeof START_FETCHING_HOOD_PRICE_CHART_DATA
>(START_FETCHING_HOOD_PRICE_CHART_DATA)

// storing
export const clearPriceChartData = createAction(CLEAR_PRICE_CHART_DATA)
export const clearHoodPriceChartData = createAction(CLEAR_HOOD_PRICE_CHART_DATA)
export const setCityPriceChartData = createAction<
  { key: string; priceChartData: PriceChartData },
  typeof SET_CITY_PRICE_CHART_DATA
>(SET_CITY_PRICE_CHART_DATA)
export const setHoodPriceChartData = createAction<
  { key: string; priceChartData: PriceChartData },
  typeof SET_HOOD_PRICE_CHART_DATA
>(SET_HOOD_PRICE_CHART_DATA)
